// <Callout type="tip" title="Boa prática"> … </Callout>
// Tipos: note (padrão), tip, warn.
import { type ReactNode } from "react";

interface CalloutProps {
  type?: "note" | "tip" | "warn";
  title?: ReactNode;
  children?: ReactNode;
}

export default function Callout({ type = "note", title, children }: CalloutProps) {
  return (
    <div className={`doc-callout doc-callout-${type}`}>
      {title && <div className="doc-callout-title">{title}</div>}
      <div>{children}</div>
    </div>
  );
}
